import { atom } from "recoil";

// KP全医療機関マスタの医療機関edit用
export const hospitalState = atom({
  key: "hospitalState",
  default: {
    id: null,
    name: '',
    abbr_name: '',
    hospital_code: '',
    zipcode: '',
    prefecture_code: null,
    area: '',
    address: '',
    represent_tel: '',
    direct_tel: '',
    pr_tel: '',
    represent_fax: '',
    direct_fax: '',
    pr_fax: '',
    email: '',
    url: '',
    mon_open: null,
    tue_open: null,
    wed_open: null,
    thu_open: null,
    fri_open: null,
    sat_open: null,
    sun_open: null,
    holiday_open: null,
    memo: '',
    access_memo: '',
    hospital_memo: '',
    contract_memo: '',
    option_memo: '',
    work_memo: '',
    gastroscope_state: '',
    gastroscope_memo: '',
    contract_state: '',
    contract_state_memo: '',
    warning_flg: null,
    unable_agency_flg: null,
    recommend_flg: null,
    created_at: '',
    updated_at: '',
  },
});